//import node_modules
import React, { FunctionComponent } from "react";
import NextLink from "@adjust/website/src/components/NextLink";
import { Pagination } from "react-bootstrap";

//hooks
import usePaginationContext from "../hooks/usePaginationContext";

const PaginationNextComponent: FunctionComponent = () => {
  const handler = usePaginationContext();

  if (handler.disabled(handler.getPageCount())) {
    return <Pagination.Next disabled={true} />;
  }

  return (
    <NextLink href={handler.generatePath(handler.getPage() + 1)}>
      <Pagination.Next />
    </NextLink>
  );
};

export default React.memo(PaginationNextComponent);
